import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import Workspace from "./pages/Workspace";
import SetPassword from "./pages/SetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import MfaSetup from "./pages/MfaSetup";

function Protected({ children, adminOnly, allowMfaSetup = false }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F7] dark:bg-[#161618]">
        <div className="w-8 h-8 rounded-full border-2 border-slate-300 border-t-[#0066CC] animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/workspace" replace />;
  if (adminOnly && !allowMfaSetup && !user.mfa_enabled) return <Navigate to="/admin/mfa-setup" replace />;
  return children;
}

function Root() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/workspace"} replace />;
}

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/invite" element={<SetPassword />} />
          <Route path="/reset" element={<SetPassword />} />
          <Route path="/invite/:token" element={<SetPassword />} />
          <Route path="/reset/:token" element={<SetPassword />} />
          <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
          <Route path="/admin/mfa-setup" element={<Protected adminOnly allowMfaSetup><MfaSetup /></Protected>} />
          <Route path="/workspace" element={<Protected><Workspace /></Protected>} />
          <Route path="/workspace/:customerId" element={<Protected adminOnly><Workspace /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
